export const MOUSEFLOW_MASKED = 'mouseflow-masked';
export const MOUSEFLOW_EXLUDED = 'mouseflow-excluded';
